<template>
  <div class="page_download">
    <div class="stepbar">
      <div class="stepbar_progress toppageStepBar">
        <div class="stepbar_track"></div>
        <div
          id="step1"
          class="stepbar_step"
          :class="{
            'is-active': !enterpw_submitted,
            'is-complete': enterpw_submitted
          }"
        >
          <p class="step_enterpw">ENTER PASSWORD</p>
          <div class="success-checkmark">
            <div class="check-icon">
              <span class="icon-line line-tip"></span>
              <span class="icon-line line-long"></span>
              <div class="icon-circle"></div>
            </div>
          </div>
        </div>
        <div
          id="step2"
          class="stepbar_step"
          :class="{
            'is-active': enterpw_submitted && !pwsubmitted,
            'is-complete': pwsubmitted
          }"
        >
          <p class="step_download">DOWNLOAD</p>
          <div class="success-checkmark">
            <div class="check-icon">
              <span class="icon-line line-tip"></span>
              <span class="icon-line line-long"></span>
              <div class="icon-circle"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <transition name="mainbody_anim" mode="out-in" v-if="!enterpw_submitted">
      <div class="enterPW">
        <div class="enterPW_circle">
          <img src="@/assets/images/password.svg" alt="パスワード" />
        </div>
        <form>
          <label class="enterPW_title">ENTER PASSWORD</label>
          <input
            type="text"
            name="password"
            class="enterPW_input"
            v-model="password"
            placeholder="パスワードを入力してください"
          />
          <input
            type="submit"
            value="START"
            class="enterPW_Btn"
            @click="donwloadStart"
          />
        </form>
      </div>
    </transition>
    <transition name="mainbody_anim" mode="out-in" v-if="enterpw_submitted">
      <div class="downloadbox">
        <div class="dld_wrapper">
          <p class="dld_title">Dear customer</p>
          <ul class="dld_icon">
            <li>
              <img
                src="@/assets/images/mail.svg"
                alt="Sender"
                class="dld_sender"
              />
            </li>
            <li>
              <img
                src="@/assets/images/airplane.svg"
                alt="Airplane"
                class="dld_airplane"
              />
            </li>
            <li>
              <img
                src="@/assets/images/person.svg"
                alt="Receiver"
                class="dld_receiver"
              />
            </li>
          </ul>
          <ul class="dld_filedetail">
            <li class="dld_filename">{{fileName}}</li>
            <!-- <li class="dld_filesize">&#47; 300MB</li> -->
          </ul>
          <ul class="dld_usedetail">
            <li>
              ダウンロード期限&#58;
              <br class="sp" />
              <span>{{expiresDate}}</span>
            </li>
            <li>
              ダウンロード回数&#58;
              <br class="sp" />残り <span>{{times}}</span>回
            </li>
          </ul>
            <!-- <input
              type="submit"
              value="DOWNLOAD"
              class="dld_Btn"
              @click.once="downloadSubmit"
              v-on:click.prevent="validate"
            /> -->
            <a :href="filePath">ダウンロード</a>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
const axios = require('axios');
// const LOGIN_URL = '/login';
const LOGIN_URL = 'https://filepassport.jp/login';
export default {
  data() {
    return {
      enterpw_submitted: false,
      pwsubmitted: false,
      password: '',
      filePath: '',
      fileNßame: '',
      expires: '',
      expiresDate: '',
      times: ''
    };
  },
  methods: {
    downloadSubmit: function(event){
    },
    donwloadStart: function(event){
      event.preventDefault();
      // 送信する値を設定
      let params = new URLSearchParams();
      params.append('user', this.$route.params.id);
      params.append('password', this.password);

      axios.post(LOGIN_URL, params).then(response => {
        if(response['data']['message'] == 'ok'){
          this.filePath = response['data']['url'];
          this.fileName = response['data']['filename'];
          this.expires = response['data']['expires'];
          this.expiresDate = response['data']['download_expires_date'];
          this.times = response['data']['times'];
          this.enterpw_submitted = !this.enterpw_submitted;
        }
      });
    }
  }
};
</script>

<style lang="scss"></style>
